// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Slabo 13px', 'Slabo 13px Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_662145"};